import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

export function FichaSkeleton() {
	return (
		<div className="flex flex-col gap-5">
			<div className="overflow-hidden rounded-xl border border-border bg-card shadow-card">
				<div className="grid grid-cols-1 border-b border-border lg:grid-cols-[minmax(0,1fr)_22rem]">
					<div className="flex items-center gap-6 px-7 py-7">
						<Skeleton className="size-24 rounded-xl bg-primary-soft" />

						<div className="flex flex-1 flex-col gap-3">
							<Skeleton className="h-5 w-28" />
							<Skeleton className="h-10 w-72 max-w-full" />
							<Skeleton className="h-4 w-96 max-w-full" />
						</div>
					</div>

					<div className="flex flex-col justify-center gap-3 border-t border-border bg-background/50 px-6 py-5 lg:border-l lg:border-t-0">
						<Skeleton className="h-8 w-full" />
						<Skeleton className="h-8 w-3/4" />
						<Skeleton className="h-10 w-full" />
					</div>
				</div>

				<div className="flex gap-2 p-2 sm:px-4">
					{Array.from({ length: 3 }, (_, index) => (
						<Skeleton key={index} className="h-10 w-32" />
					))}
				</div>
			</div>

			<div className="grid grid-cols-1 items-start gap-5 lg:grid-cols-2">
				<div className="flex flex-col gap-5">
					{Array.from({ length: 2 }, (_, index) => (
						<Card key={index}>
							<CardHeader>
								<Skeleton className="h-6 w-40" />
							</CardHeader>

							<CardContent className="grid grid-cols-2 gap-4">
								<Skeleton className="h-10 w-full" />
								<Skeleton className="h-10 w-full" />
								<Skeleton className="col-span-2 h-10 w-full" />
							</CardContent>
						</Card>
					))}
				</div>

				<div className="flex flex-col gap-5">
					{Array.from({ length: 3 }, (_, i) => (
						<Card key={i}>
							<CardHeader>
								<Skeleton className="h-5 w-32" />
							</CardHeader>

							<CardContent className="flex flex-col gap-3">
								<Skeleton className="h-4 w-full" />
								<Skeleton className="h-4 w-3/4" />
								<Skeleton className="h-4 w-2/3" />
							</CardContent>
						</Card>
					))}
				</div>
			</div>

			<div className="grid grid-cols-1 items-start gap-5 xl:grid-cols-[minmax(24rem,0.8fr)_minmax(0,1.2fr)]">
				<div className="flex flex-col gap-5">
					<Skeleton className="h-72 w-full rounded-xl" />
					<div className="grid grid-cols-2 gap-5 xl:grid-cols-1">
						<Skeleton className="h-32 w-full rounded-xl" />
						<Skeleton className="h-32 w-full rounded-xl" />
					</div>
				</div>

				<Skeleton className="h-160 w-full rounded-xl" />
			</div>
		</div>
	);
}
